// Colour scheme: follows the system by default, with a per-device override
// kept in localStorage. Web Awesome's dark palette is active while <html>
// carries the wa-dark class.

export type Theme = 'system' | 'light' | 'dark';

const storageKey = 'psa.theme';
const media = window.matchMedia('(prefers-color-scheme: dark)');

export function getTheme(): Theme {
  try {
    const v = localStorage.getItem(storageKey);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

export function setTheme(theme: Theme) {
  try {
    if (theme === 'system') localStorage.removeItem(storageKey);
    else localStorage.setItem(storageKey, theme);
  } catch {
    // storage unavailable (private mode): the choice lasts for this page only
  }
  apply();
  window.dispatchEvent(new CustomEvent('psa-theme-change', { detail: theme }));
}

/** True when the dark palette is in effect right now. */
export function isDark(): boolean {
  const t = getTheme();
  return t === 'dark' || (t === 'system' && media.matches);
}

function apply() {
  const dark = isDark();
  document.documentElement.classList.toggle('wa-dark', dark);
  document.documentElement.classList.toggle('wa-light', !dark);
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
}

export function initTheme() {
  apply();
  media.addEventListener('change', () => {
    if (getTheme() === 'system') apply();
  });
}
